import { render, staticRenderFns } from "./ProductScroll.vue?vue&type=template&id=3bb87f08&scoped=true"
import script from "./ProductScroll.vue?vue&type=script&lang=js"
export * from "./ProductScroll.vue?vue&type=script&lang=js"
import style0 from "./ProductScroll.vue?vue&type=style&index=0&id=3bb87f08&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb87f08",
  null
  
)

export default component.exports